import { instance as axios, setJwtToken, setMultiPartHeader } from "../../config/axiosInstance"

//---------------------category-listing------------------------------
export const fathCategoryApi = async (data) => {
    const endPoint = `/category/list` + `?` + new URLSearchParams({ ...data }).toString()
    return await axios.get(endPoint, setJwtToken())
}

//--------------------add-category-------------------------------
export const addCategoryApi = async (data) => {
    const endPoint = `/category/add`
    return await axios.post(endPoint, data, setMultiPartHeader())
}

//--------------------add-category-------------------------------
export const blockCategoryApi = async (data) => {
    const endPoint = `/category/update_status`
    return await axios.put(endPoint, data, setMultiPartHeader())
}

export const updateCategoryApi = async (data) => {
    const endPoint = `/category/update`
    return await axios.put(endPoint, data, setMultiPartHeader())

}